import React from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import axios from 'axios';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import { Container, Row, Col } from "shards-react";
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
  //import { Store } from "../../flux";
import  api from '../common/api';
import CuitVerification from './CuitVerification'

class PendingCuitVerification extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        isLoaded: false,
        peding_cuit_verification:[],
        dialog:{contact_id:'', open:''}
      }
    }

    async componentDidMount() {
      await this.getPendingCuitVerification();
	    const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get('contact_id')){
        this.setState({contact_id: searchParams.get('contact_id')})
      }
    }
   
    getPendingCuitVerification(){
     const token = localStorage.getItem('userToken')

     return axios
              .get(api.work_order().peding_cuit_verification(),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                this.setState({isLoaded: true, peding_cuit_verification: res.data})
              })
              .catch(err =>{
                this.setState({isLoaded: true, peding_cuit_verification: [] })
              })
    }

    handleDialog = (e, contact_id) => {
      e.preventDefault();
      var dialog = this.state.dialog
      dialog.open = !dialog.open
      dialog.contact_id = contact_id
      this.setState({dialog})
      if (!dialog.open){
        this.getPendingCuitVerification()
      }
    }

    getMuiTheme = () =>
      createMuiTheme({
        overrides: {
          MuiTableCell: {
           root: {
             padding: '0px 8px 0px 8px',
             fontSize: '0.73rem'
            }
          }
        }
    });      



    render(){
       const columns = [
       {
        name: "id",
        label: "Id",
        options: {
         filter: false,
         display: false,
         sort: true,
        }
       },
       {
        name: "business_name",
        label: "Proveedor",
        options: {
         filter: true,
         filterType: "textField",
         sort: true,
         setCellProps: () => ({ style: { minWidth: "150px", maxWidth: "150px" }}),
         /*customBodyRender : (value, tableMeta, updateValue) => {
            return (
              <Typography component={'span'} noWrap={false} style={{fontSize: '0.75rem'}}>
                {value}
              </Typography>
            )
          }*/       
        }
       },
       {
        name: "cuit_date_verification",
        label: "Ultima verificación",
        options: {
         filter: true,
         filterType: "textField",
         sort: true,
        }
       },
       {
        name: "id",
        label: "OT",
        options: {
         filter: true,
         filterType: "textField",
         sort: true,
        }
       },
       {
        name: "work_order_type",
        label: "Tipo OT",
        options: {
         filter: true,
         filterType: "textField",
         sort: true,
        }
       },
       {
        name: "state",
        label: "Estado",
        options: {
         filter: true,
         filterType: "textField",
         sort: true,
        }
       },
       {
        name: "provider_contact_id",
        label: "provider_contact_id",
        options: {
         filter: true,
         filterType:'textField',
         filterList: (this.state.contact_id) ? [parseInt(this.state.contact_id)] : '',         
         display: false,
         sort: true,
        }
       },{
        name: "Acciones",
        label: "",
        options: {
            filter: false,
            setCellHeaderProps: () => ({ align: 'right' }),
            customBodyRender: (value, tableMeta, updateValue) => {
              const contact_id = tableMeta.rowData[6]

              return (
                <div className="row" style={{display: 'block', textAlign: 'right', paddingRight: '30px'}}>
                  <Fab color="primary" aria-label="view"  variant="extended" style={{boxShadow: 'none', backgroundColor: "green" }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' onClick={(e) => {this.handleDialog(e, contact_id)}} >
                    <EditIcon fontSize="small" /> 
                  </Fab>
                </div>
                  )}
            }
       }     
      ];


    const options = {
      print:false,
      responsive: 'stacked',
      selectableRowsOnClick: false,
      download: false,
      rowsPerPage: 10,
      textLabels: {
            toolbar: {
              search: "Buscar",
              viewColumns: "Ver columnas",
              filterTable: "Filtros",   
              downloadCsv: "Exportar XLS",
            },
            body: {
                noMatch: this.state.isLoaded ?
                    'No hay resultados' :
                    <CircularProgress />,
            },
            selectedRows: {
              text: "fila(s) seleccionadas"
            },
            viewColumns: {
              title: "Ver columnas",
            },
            pagination: {
              next: "Siguiente",
              previous: "Anteior",
              rowsPerPage: "Cantidad por página:",
              displayRows: "de",      
            },
            filter: {
              all: "Todos",
              title: "Filtros",
              reset: "Limpiar"
            }
        }
    };

     return(
        <Container fluid className="main-content-container px-4">
             <Dialog
                open={this.state.dialog.open}
                maxWidth='xl'
                onClose={(e)=>this.handleDialog(e, '')}
                fullWidth={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
              <DialogTitle id="alert-dialog-title" onClose={(e)=>this.handleDialog(e, '')}>Verificación CUIT</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <CuitVerification contact_id={this.state.dialog.contact_id} dialog={this.state.dialog}/>                  
                </DialogContentText>
              </DialogContent>
            </Dialog> 
            
            <Row>
              <Col className="p-2">
                <div>
                 <MuiThemeProvider theme={this.getMuiTheme()}>
                  <MUIDataTable
                    title="Proveedores sin verificar"
                    data={Object.values(this.state.peding_cuit_verification)}
                    columns={columns}
                    options={options}
                   />
                </MuiThemeProvider>
                </div>
              </Col>
            </Row>
           </Container>
      );
    }

}

export default PendingCuitVerification;   